module.exports = __webpack_public_path__ + "media/application/images/ui/blurred-background-0f1ea7ec543e337b767a816c08d98ec3.png";